var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-bank-list"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-top"},[_c('img',{attrs:{"src":require("@/assets/style/add-card-logo.png"),"alt":""}}),_c('span',[_vm._v("中国建设银行")])]),_c('div',{staticClass:"left-bottom"},[_vm._v("2312 **** **** 2312")])]),_c('div',{staticClass:"right-set"},[_c('input',{attrs:{"type":"checkbox"}})])])
}]

export { render, staticRenderFns }